import React, { useState } from "react";

function Addblogs() {
  const [step, setStep] = useState(1);
  const [image, setImage] = useState('');
  const [blogData, setBlogData] = useState({
    title: '',
    description: '',
    name: '',
    location: ''
  });

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => setImage(e.target.result);
    reader.readAsDataURL(file);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBlogData({
      ...blogData,
      [name]: value
    });
  };

  return (
<div className="flex flex-col items-center justify-center min-h-screen p-6 bg-gray-100 md:p-1 dark:bg-gray-800">
  <div className="w-full max-w-xl p-6 bg-white rounded-lg shadow-lg dark:bg-gray-700">
    <div className="text-center">
      <h1 className="mb-4 text-3xl font-bold text-gray-800 dark:text-gray-100">Post News</h1>
      <div className="w-full h-1 mx-auto mb-4 bg-blue-500 rounded-full dark:bg-blue-300"></div>
      <div className="text-sm font-semibold text-gray-500 dark:text-gray-400">Step {step} of 3</div>
    </div>
    <div className="flex flex-col space-y-4">
      {step === 1 && (
        <div className="flex flex-col space-y-4">
          <div className="w-1/3 h-2 mx-auto mt-1 mb-6 bg-gray-200 rounded-full dark:bg-gray-600">
            <div className="w-1/3 h-full text-center text-white bg-green-600 rounded-full dark:bg-green-400"></div>
          </div>
          <label className="text-sm font-semibold text-gray-600 dark:text-gray-300">Upload an Image</label>
          <div className="relative bg-gray-100 border rounded-lg dark:bg-gray-600">
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="absolute inset-0 w-full h-full p-4 opacity-0 cursor-pointer"
            />
            {image ? (
              <div className="w-full h-64">
                <img src={image} alt="Selected" className="object-cover w-full h-full" />
              </div>
            ) : (
              <img
                src="https://api.iconify.design/solar:gallery-send-outline.svg?color=%23525252"
                alt="Upload"
                className="w-40 h-40 m-auto"
              />
            )}
          </div>
        </div>
      )}
      {step === 2 && (
        <div className="flex flex-col w-[100%]">
          <div className="w-1/3 h-2 mx-auto mt-1 mb-6 bg-gray-200 rounded-full dark:bg-gray-600">
            <div className="w-2/3 h-full text-center text-white bg-green-600 rounded-full dark:bg-green-400"></div>
          </div>
          {image && (
            <div className="flex items-center justify-center m-auto">
              <img src={image} alt="Selected" className="w-1/3 object-fit" />
            </div>
          )}

          <label className="text-sm font-semibold text-gray-600 dark:text-gray-300 text-start">News Title</label>
          <input
            type="text"
            name="name"
            value={blogData.name}
            onChange={handleInputChange}
            required
            className="w-full px-2 py-2 mb-4 text-gray-700 border rounded-lg focus:outline-none focus:border-indigo-500 dark:bg-gray-700 dark:text-white"
          />
          <label className="text-sm font-semibold text-gray-600 dark:text-gray-300 text-start">News Description</label>
          <textarea
            name="description"
            value={blogData.description}
            onChange={handleInputChange}
            required
            className="w-full px-2 py-2 text-gray-700 border rounded-lg focus:outline-none focus:border-indigo-500 dark:bg-gray-700 dark:text-white"
          />
        </div>
      )}

      {step === 3 && (
        <div className="flex flex-col space-y-4">
          <div className="w-1/3 h-2 mx-auto mt-1 mb-6 bg-gray-200 rounded-full dark:bg-gray-600">
            <div className="h-full text-center text-white bg-green-600 rounded-full dark:bg-green-400 w-3/3"></div>
          </div>
          <label className="text-sm font-semibold text-gray-600 dark:text-gray-300">MAP AAYEGA YAHAN</label>
        </div>
      )}
    </div>
    <div className="flex justify-between mt-8">
      {step > 1 && (
        <button
          onClick={() => setStep(step - 1)}
          className="px-4 py-2 font-medium text-gray-500 bg-transparent rounded-lg shadow-none hover:text-gray-700 dark:text-gray-300"
        >
          Previous
        </button>
      )}
      {step < 3 && (
        <button
          onClick={() => setStep(step + 1)}
          className="px-4 py-2 font-medium text-white bg-[#3B7BD3] border rounded-lg shadow-none focus:outline-none hover:bg-[#3B7BD3]/80"
        >
          Next &nbsp; &rarr;
        </button>
      )}
      {step === 3 && (
        <button
          onClick={() => alert('✔ News Posted Successfully')}
          className="px-4 py-2 font-medium text-white bg-green-600 border rounded-lg shadow-none focus:outline-none hover:bg-green-700 dark:bg-green-400"
        >
          Post
        </button>
      )}
    </div>
  </div>
</div>
  );
}

export default Addblogs;
